// src/components/molecules/auth/auth-password-field.tsx
"use client";

import * as React from "react";
import { Eye, EyeOff, Lock } from "lucide-react";
import { AuthTextField } from "./auth-text-field";

type AuthPasswordFieldProps = Omit<
  React.ComponentProps<typeof AuthTextField>,
  "icon" | "type" | "trailing"
> & {
  label?: string;
};

export function AuthPasswordField({
  id,
  label = "Password",
  ...props
}: AuthPasswordFieldProps) {
  const [show, setShow] = React.useState(false);

  return (
    // AuthTextField (out of scope for this task) renders the input and the
    // `trailing` toggle button inside its own single root — this wrapper div
    // is the only way to attach data-ph-no-capture to that pair without
    // touching that file. ph-no-capture is the class posthog-js autocapture
    // honours; data-ph-no-capture is the one session replay's blockSelector uses.
    <div data-ph-no-capture className="ph-no-capture">
      <AuthTextField
        {...props}
        id={id}
        label={label}
        type={show ? "text" : "password"}
        icon={<Lock className="size-5" />}
        trailing={
          <button
            type="button"
            onClick={() => setShow((value) => !value)}
            aria-pressed={show}
            aria-label={show ? "Hide password" : "Show password"}
            className="grid size-11 shrink-0 place-items-center rounded-lg text-brand-ink/60 transition-colors hover:text-brand focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand"
          >
            {show ? <EyeOff className="size-5" /> : <Eye className="size-5" />}
          </button>
        }
      />
    </div>
  );
}
